import React from "react";

const Songdo7thSeatSvg: React.FC<any> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1132"
            height="1597"
            viewBox="0 0 1132 1597"
        >
            <g transform="translate(5.5 5.5)">
                <path fill="none" d="M0 0h1123v1587H0z"></path>
                <g id="shape1">
                    <path fill="#7e7e7e" d="M953.613 115.576h-839.2v7.6h839.2v-7.6"></path>
                    <path
                        fill="none"
                        stroke="#7e7e7e"
                        d="M953.613 115.576h-839.2m0 7.6h839.2m0-7.6v7.6m-839.2-7.6v7.6"
                    ></path>
                </g>
                <g id="shape2">
                    <path
                        fill="#7e7e7e"
                        d="M113.61 119.355v933.6h2.8v-2.3l3.8-3.8h1v-927.5z"
                    ></path>
                    <path
                        fill="none"
                        stroke="#7e7e7e"
                        d="M113.61 119.355v933.6m7.6 0v-933.6m-7.6 0h7.6m-7.6 933.6h7.6"
                    ></path>
                </g>
                <g id="shape3">
                    <path fill="#7e7e7e" d="M946.656 121.712v932h7.6v-932h-7.6"></path>
                    <path
                        fill="none"
                        stroke="#7e7e7e"
                        d="M946.656 121.712v932m7.6 0v-932m-7.6 0h7.6m-7.6 932h7.6"
                    ></path>
                </g>
                <g id="shape4">
                    <path fill="#7e7e7e" d="M948.221 1045.891h-832.8v7.6h832.8v-7.6"></path>
                    <path
                        fill="none"
                        stroke="#7e7e7e"
                        d="M948.221 1045.891h-832.8m0 7.6h832.8m0-7.6v7.6m-832.8-7.6v7.6"
                    ></path>
                </g>
                <g id="410">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M174.077 193.181h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(174.077 193.181)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            41
                        </tspan>
                    </text>
                </g>
                <g id="411">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.077 218.88h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.077 218.88)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="412">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.077 244.58h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.077 244.58)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="340">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M265.156 193.181h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(265.156 193.181)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            34
                        </tspan>
                    </text>
                </g>
                <g id="341">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.156 218.88h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.156 218.88)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="342">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.156 244.58h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.156 244.58)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="420">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M174.076 295.969h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(174.076 295.969)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            42
                        </tspan>
                    </text>
                </g>
                <g id="421">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 321.668h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 321.668)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="422">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 347.367h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 347.367)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="350">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M265.155 295.969h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(265.155 295.969)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            35
                        </tspan>
                    </text>
                </g>
                <g id="351">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 321.668h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 321.668)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="352">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 347.367h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 347.367)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="430">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M174.076 398.756h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(174.076 398.756)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            43
                        </tspan>
                    </text>
                </g>
                <g id="431">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 424.455h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 424.455)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="432">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 450.154h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 450.154)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="360">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M265.156 398.756h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(265.156 398.756)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            36
                        </tspan>
                    </text>
                </g>
                <g id="361">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 424.455h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 424.455)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="362">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 450.154h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 450.154)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="440">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M174.076 501.543h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(174.076 501.543)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            44
                        </tspan>
                    </text>
                </g>
                <g id="441">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 527.242h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 527.242)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="442">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 552.94h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 552.94)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="370">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M265.156 501.543h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(265.156 501.543)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            37
                        </tspan>
                    </text>
                </g>
                <g id="371">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 527.242h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 527.242)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="372">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 552.94h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 552.94)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="450">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M174.076 604.33h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(174.076 604.33)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            45
                        </tspan>
                    </text>
                </g>
                <g id="451">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 630.029h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 630.029)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="452">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 655.728h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 655.728)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="380">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M265.156 604.33h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(265.156 604.33)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            38
                        </tspan>
                    </text>
                </g>
                <g id="381">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 630.029h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 630.029)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="382">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 655.728h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 655.728)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="460">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M174.076 707.117h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(174.076 707.117)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            46
                        </tspan>
                    </text>
                </g>
                <g id="461">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 732.816h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 732.816)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="462">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 758.515h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 758.515)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="390">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M265.155 707.117h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(265.155 707.117)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            39
                        </tspan>
                    </text>
                </g>
                <g id="391">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 732.816h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 732.816)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="392">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 758.515h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 758.515)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="470">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M174.076 809.904h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(174.076 809.904)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            47
                        </tspan>
                    </text>
                </g>
                <g id="471">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 835.603h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 835.603)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="472">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M174.076 861.302h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(174.076 861.302)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="400">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M265.155 809.904h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(265.155 809.904)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            40
                        </tspan>
                    </text>
                </g>
                <g id="401">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 835.603h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 835.603)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="402">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M265.155 861.302h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(265.155 861.302)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="270">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M385.358 193.182h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(385.358 193.182)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            27
                        </tspan>
                    </text>
                </g>
                <g id="271">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 218.88h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 218.88)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="272">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 244.58h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 244.58)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="200">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M476.436 193.182h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(476.436 193.182)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            20
                        </tspan>
                    </text>
                </g>
                <g id="201">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 218.88h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 218.88)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="202">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 244.58h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 244.58)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="280">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M385.358 295.97h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(385.358 295.97)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            28
                        </tspan>
                    </text>
                </g>
                <g id="281">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 321.668h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 321.668)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="282">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 347.367h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 347.367)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="210">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M476.436 295.97h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(476.436 295.97)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            21
                        </tspan>
                    </text>
                </g>
                <g id="211">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 321.668h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 321.668)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="212">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 347.367h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 347.367)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="290">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M385.358 398.756h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(385.358 398.756)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            29
                        </tspan>
                    </text>
                </g>
                <g id="291">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 424.455h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 424.455)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="292">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 450.154h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 450.154)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="220">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M476.436 398.756h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(476.436 398.756)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            22
                        </tspan>
                    </text>
                </g>
                <g id="221">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 424.455h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 424.455)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="222">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 450.154h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 450.154)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="300">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M385.358 501.543h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(385.358 501.543)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            30
                        </tspan>
                    </text>
                </g>
                <g id="301">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 527.242h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 527.242)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="302">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 552.941h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 552.941)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="230">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M476.436 501.543h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(476.436 501.543)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            23
                        </tspan>
                    </text>
                </g>
                <g id="231">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 527.242h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 527.242)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="232">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 552.941h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 552.941)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="310">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M385.358 604.33h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(385.358 604.33)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            31
                        </tspan>
                    </text>
                </g>
                <g id="311">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 630.03h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 630.03)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="312">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 655.728h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 655.728)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="240">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M476.436 604.33h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(476.436 604.33)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            24
                        </tspan>
                    </text>
                </g>
                <g id="241">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 630.03h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 630.03)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="242">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 655.728h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 655.728)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="320">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M385.358 707.117h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(385.358 707.117)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            32
                        </tspan>
                    </text>
                </g>
                <g id="321">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 732.816h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 732.816)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="322">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 758.515h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 758.515)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="250">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M476.436 707.117h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(476.436 707.117)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            25
                        </tspan>
                    </text>
                </g>
                <g id="251">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 732.816h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 732.816)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="252">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 758.515h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 758.515)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="330">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M385.358 809.904h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(385.358 809.904)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            33
                        </tspan>
                    </text>
                </g>
                <g id="331">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 835.603h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 835.603)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="332">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M385.358 861.302h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(385.358 861.302)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="260">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M476.436 809.904h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(476.436 809.904)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            26
                        </tspan>
                    </text>
                </g>
                <g id="261">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 835.603h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 835.603)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="262">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M476.436 861.302h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(476.436 861.302)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="140">
                    <path
                        fill="#eef4ff"
                        stroke="#323232"
                        d="M596.639 193.182h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(596.639 193.182)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            14
                        </tspan>
                    </text>
                </g>
                <g id="141">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 218.88h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 218.88)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="142">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 244.58h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 244.58)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="80">
                    <path
                        fill="#ffecec"
                        stroke="#323232"
                        d="M687.717 193.182h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(687.717 193.182)"
                    >
                        <tspan x="41.5" y="17.3" fontSize="13" >
                            8
                        </tspan>
                    </text>
                </g>
                <g id="81">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 218.88h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 218.88)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="82">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 244.58h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 244.58)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="150">
                    <path
                        fill="#eef4ff"
                        stroke="#323232"
                        d="M596.639 295.97h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(596.639 295.97)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            15
                        </tspan>
                    </text>
                </g>
                <g id="151">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 321.668h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 321.668)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="152">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 347.367h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 347.367)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="90">
                    <path
                        fill="#ffecec"
                        stroke="#323232"
                        d="M687.717 295.97h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(687.717 295.97)"
                    >
                        <tspan x="41.5" y="17.3" fontSize="13" >
                            9
                        </tspan>
                    </text>
                </g>
                <g id="91">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 321.668h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 321.668)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="92">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 347.367h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 347.367)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="160">
                    <path
                        fill="#eef4ff"
                        stroke="#323232"
                        d="M596.639 398.756h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(596.639 398.756)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            16
                        </tspan>
                    </text>
                </g>
                <g id="161">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 424.455h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 424.455)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="162">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 450.154h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 450.154)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="100">
                    <path
                        fill="#ffecec"
                        stroke="#323232"
                        d="M687.717 398.756h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(687.717 398.756)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            10
                        </tspan>
                    </text>
                </g>
                <g id="101">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 424.455h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 424.455)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="102">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 450.154h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 450.154)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="170">
                    <path
                        fill="#eef4ff"
                        stroke="#323232"
                        d="M596.639 501.543h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(596.639 501.543)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            17
                        </tspan>
                    </text>
                </g>
                <g id="171">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 527.242h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 527.242)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="172">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 552.941h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 552.941)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="110">
                    <path
                        fill="#ffecec"
                        stroke="#323232"
                        d="M687.717 501.543h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(687.717 501.543)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            11
                        </tspan>
                    </text>
                </g>
                <g id="111">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 527.242h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 527.242)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="112">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 552.941h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 552.941)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="180">
                    <path
                        fill="#eef4ff"
                        stroke="#323232"
                        d="M596.639 604.33h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(596.639 604.33)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            18
                        </tspan>
                    </text>
                </g>
                <g id="181">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 630.03h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 630.03)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="182">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 655.728h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 655.728)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="120">
                    <path
                        fill="#ffecec"
                        stroke="#323232"
                        d="M687.717 604.33h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(687.717 604.33)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            12
                        </tspan>
                    </text>
                </g>
                <g id="121">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 630.03h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 630.03)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="122">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 655.728h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 655.728)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="190">
                    <path
                        fill="#eef4ff"
                        stroke="#323232"
                        d="M596.639 707.117h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(596.639 707.117)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            19
                        </tspan>
                    </text>
                </g>
                <g id="191">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 732.816h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 732.816)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="192">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M596.639 758.515h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(596.639 758.515)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="130">
                    <path
                        fill="#ffecec"
                        stroke="#323232"
                        d="M687.717 707.117h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(687.717 707.117)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            13
                        </tspan>
                    </text>
                </g>
                <g id="131">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 732.816h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 732.816)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="132">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M687.717 758.515h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(687.717 758.515)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="10">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M807.92 193.182h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(807.92 193.182)"
                    >
                        <tspan x="41.5" y="17.3" fontSize="13" >
                            1
                        </tspan>
                    </text>
                </g>
                <g id="11">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 218.88h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 218.88)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="12">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 244.58h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 244.58)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="20">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M807.92 295.97h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(807.92 295.97)"
                    >
                        <tspan x="41.5" y="17.3" fontSize="13" >
                            2
                        </tspan>
                    </text>
                </g>
                <g id="21">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 321.669h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 321.669)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="22">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 347.368h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 347.368)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="30">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M807.92 398.758h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(807.92 398.758)"
                    >
                        <tspan x="41.5" y="17.3" fontSize="13" >
                            3
                        </tspan>
                    </text>
                </g>
                <g id="31">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 424.457h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 424.457)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="32">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 450.156h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 450.156)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="40">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M807.92 501.543h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(807.92 501.543)"
                    >
                        <tspan x="41.5" y="17.3" fontSize="13" >
                            4
                        </tspan>
                    </text>
                </g>
                <g id="41">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 527.242h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 527.242)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="42">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 552.94h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 552.94)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="50">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M807.92 604.328h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(807.92 604.328)"
                    >
                        <tspan x="41.5" y="17.3" fontSize="13" >
                            5
                        </tspan>
                    </text>
                </g>
                <g id="51">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 630.027h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 630.027)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="52">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 655.726h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 655.726)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="60">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M807.92 707.113h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(807.92 707.113)"
                    >
                        <tspan x="41.5" y="17.3" fontSize="13" >
                            6
                        </tspan>
                    </text>
                </g>
                <g id="61">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 732.812h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 732.812)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="62">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 758.511h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 758.511)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="70">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M807.92 809.904h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(807.92 809.904)"
                    >
                        <tspan x="41.5" y="17.3" fontSize="13" >
                            7
                        </tspan>
                    </text>
                </g>
                <g id="71">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 835.603h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 835.603)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="72">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M807.92 861.302h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(807.92 861.302)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="group146" transform="rotate(-90 960.862 67.357)">
                    <g id="shape147">
                        <path
                            fill="#fff"
                            d="M19.085 52.913h52.9v7.6h-52.9zm0 0v7.6h-4v-7.6zm52.9 0v7.6h4v-7.6zm0 0V.013h-4v52.9z"
                        ></path>
                        <path
                            fill="none"
                            stroke="#303030"
                            d="M19.085 52.913c0-29.2 23.7-52.9 52.9-52.9m-52.9 52.9v7.6h-4v-7.6zm52.9 0v7.6h4v-7.6zm0 0V.013h-4v52.9z"
                        ></path>
                    </g>
                    <g id="shape148">
                        <path fill="#fff" stroke="#323232" d="M0 60.473h91.1v25.7H0z"></path>
                        <text
                            xmlSpace="preserve"
                            fill="#191919"
                            fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                            fontSize="17"
                            fontWeight="bold"
                            transform="translate(0 60.473)"
                        >
                            <tspan x="32.5" y="17.3" fontSize="13" >
                                입구
                            </tspan>
                        </text>
                    </g>
                </g>
                {/* ===== 송도 7층 방1~3 (48~60번) ===== */}
                <g id="room-wall-top">
                    <path fill="#7e7e7e" d="M130 1140h801.6v7.6h-801.6z"></path>
                    <path fill="none" stroke="#7e7e7e" d="M130 1140h801.6v7.6h-801.6z"></path>
                </g>
                <g id="room-wall-bottom">
                    <path fill="#7e7e7e" d="M130 1452.4h801.6v7.6h-801.6z"></path>
                    <path fill="none" stroke="#7e7e7e" d="M130 1452.4h801.6v7.6h-801.6z"></path>
                </g>
                <g id="room-wall-left">
                    <path fill="#7e7e7e" d="M130 1140h7.6v320h-7.6z"></path>
                    <path fill="none" stroke="#7e7e7e" d="M130 1140h7.6v320h-7.6z"></path>
                </g>
                <g id="room-wall-right">
                    <path fill="#7e7e7e" d="M924 1140h7.6v320h-7.6z"></path>
                    <path fill="none" stroke="#7e7e7e" d="M924 1140h7.6v320h-7.6z"></path>
                </g>
                <g id="room-wall-div1">
                    <path fill="#7e7e7e" d="M464 1140h7.6v320h-7.6z"></path>
                    <path fill="none" stroke="#7e7e7e" d="M464 1140h7.6v320h-7.6z"></path>
                </g>
                <g id="room-wall-div2">
                    <path fill="#7e7e7e" d="M694 1140h7.6v320h-7.6z"></path>
                    <path fill="none" stroke="#7e7e7e" d="M694 1140h7.6v320h-7.6z"></path>
                </g>
                <text
                    xmlSpace="preserve"
                    fill="#191919"
                    fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                    fontSize="20"
                    fontWeight="bold"
                    textAnchor="middle"
                    transform="translate(300.8 1172)"
                >
                    <tspan x="0" y="0">방1</tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    fill="#191919"
                    fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                    fontSize="20"
                    fontWeight="bold"
                    textAnchor="middle"
                    transform="translate(582.8 1172)"
                >
                    <tspan x="0" y="0">방2</tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    fill="#191919"
                    fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                    fontSize="20"
                    fontWeight="bold"
                    textAnchor="middle"
                    transform="translate(812.8 1172)"
                >
                    <tspan x="0" y="0">방3</tspan>
                </text>
                <g id="480">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M149.6 1185h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(149.6 1185)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            48
                        </tspan>
                    </text>
                </g>
                <g id="481">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M149.6 1210.7h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(149.6 1210.7)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="482">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M149.6 1236.4h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(149.6 1236.4)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="490">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M254.7 1185h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(254.7 1185)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            49
                        </tspan>
                    </text>
                </g>
                <g id="491">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M254.7 1210.7h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(254.7 1210.7)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="492">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M254.7 1236.4h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(254.7 1236.4)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="500">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M359.8 1185h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(359.8 1185)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            50
                        </tspan>
                    </text>
                </g>
                <g id="501">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M359.8 1210.7h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(359.8 1210.7)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="502">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M359.8 1236.4h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(359.8 1236.4)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="510">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M149.6 1282.1h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(149.6 1282.1)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            51
                        </tspan>
                    </text>
                </g>
                <g id="511">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M149.6 1307.8h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(149.6 1307.8)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="512">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M149.6 1333.5h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(149.6 1333.5)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="520">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M254.7 1282.1h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(254.7 1282.1)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            52
                        </tspan>
                    </text>
                </g>
                <g id="521">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M254.7 1307.8h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(254.7 1307.8)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="522">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M254.7 1333.5h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(254.7 1333.5)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="530">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M359.8 1282.1h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(359.8 1282.1)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            53
                        </tspan>
                    </text>
                </g>
                <g id="531">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M359.8 1307.8h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(359.8 1307.8)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="532">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M359.8 1333.5h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(359.8 1333.5)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="540">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M484.6 1185h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(484.6 1185)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            54
                        </tspan>
                    </text>
                </g>
                <g id="541">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M484.6 1210.7h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(484.6 1210.7)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="542">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M484.6 1236.4h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(484.6 1236.4)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="550">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M589.7 1185h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(589.7 1185)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            55
                        </tspan>
                    </text>
                </g>
                <g id="551">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M589.7 1210.7h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(589.7 1210.7)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="552">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M589.7 1236.4h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(589.7 1236.4)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="560">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M484.6 1282.1h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(484.6 1282.1)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            56
                        </tspan>
                    </text>
                </g>
                <g id="561">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M484.6 1307.8h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(484.6 1307.8)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="562">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M484.6 1333.5h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(484.6 1333.5)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="570">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M589.7 1282.1h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(589.7 1282.1)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            57
                        </tspan>
                    </text>
                </g>
                <g id="571">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M589.7 1307.8h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(589.7 1307.8)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="572">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M589.7 1333.5h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(589.7 1333.5)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="580">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M710.6 1185h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(710.6 1185)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            58
                        </tspan>
                    </text>
                </g>
                <g id="581">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M710.6 1210.7h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(710.6 1210.7)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="582">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M710.6 1236.4h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(710.6 1236.4)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="590">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M815.7 1185h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(815.7 1185)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            59
                        </tspan>
                    </text>
                </g>
                <g id="591">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M815.7 1210.7h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(815.7 1210.7)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="592">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M815.7 1236.4h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(815.7 1236.4)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g id="600">
                    <path
                        fill="#d7d7d7"
                        stroke="#323232"
                        d="M710.6 1282.1h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        fontWeight="bold"
                        transform="translate(710.6 1282.1)"
                    >
                        <tspan x="37.5" y="17.3" fontSize="13" >
                            60
                        </tspan>
                    </text>
                </g>
                <g id="601">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M710.6 1307.8h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(710.6 1307.8)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            이름
                        </tspan>
                    </text>
                </g>
                <g id="602">
                    <path
                        fill="#fff"
                        stroke="#323232"
                        d="M710.6 1333.5h91.1v25.7h-91.1z"
                    ></path>
                    <text
                        xmlSpace="preserve"
                        fill="#191919"
                        fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                        fontSize="17"
                        transform="translate(710.6 1333.5)"
                    >
                        <tspan x="32.5" y="17.3" fontSize="13" >
                            메모
                        </tspan>
                    </text>
                </g>
                <g transform="translate(-479.563 402.73)">
                    <path
                        fill="#fff"
                        d="M806.813 1049.67h-52.9v7.6h52.9zm0 0v7.6h4v-7.6zm-52.9 0v7.6h-4v-7.6zm0 0v-52.9h4v52.9z"
                    ></path>
                    <path
                        fill="none"
                        stroke="#303030"
                        d="M806.813 1049.67c0-29.2-23.7-52.9-52.9-52.9m52.9 52.9v7.6h4v-7.6zm-52.9 0v7.6h-4v-7.6zm0 0v-52.9h4v52.9z"
                    ></path>
                </g>
                <g transform="translate(-197.563 402.73)">
                    <path
                        fill="#fff"
                        d="M806.813 1049.67h-52.9v7.6h52.9zm0 0v7.6h4v-7.6zm-52.9 0v7.6h-4v-7.6zm0 0v-52.9h4v52.9z"
                    ></path>
                    <path
                        fill="none"
                        stroke="#303030"
                        d="M806.813 1049.67c0-29.2-23.7-52.9-52.9-52.9m52.9 52.9v7.6h4v-7.6zm-52.9 0v7.6h-4v-7.6zm0 0v-52.9h4v52.9z"
                    ></path>
                </g>
                <g transform="translate(32.437 402.73)">
                    <path
                        fill="#fff"
                        d="M806.813 1049.67h-52.9v7.6h52.9zm0 0v7.6h4v-7.6zm-52.9 0v7.6h-4v-7.6zm0 0v-52.9h4v52.9z"
                    ></path>
                    <path
                        fill="none"
                        stroke="#303030"
                        d="M806.813 1049.67c0-29.2-23.7-52.9-52.9-52.9m52.9 52.9v7.6h4v-7.6zm-52.9 0v7.6h-4v-7.6zm0 0v-52.9h4v52.9z"
                    ></path>
                </g>
                <text
                    xmlSpace="preserve"
                    fill="#191919"
                    fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                    fontSize="14"
                    textAnchor="middle"
                    transform="translate(300.8 1478)"
                >
                    <tspan x="0" y="0">출입문</tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    fill="#191919"
                    fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                    fontSize="14"
                    textAnchor="middle"
                    transform="translate(582.8 1478)"
                >
                    <tspan x="0" y="0">출입문</tspan>
                </text>
                <text
                    xmlSpace="preserve"
                    fill="#191919"
                    fontFamily="맑은 고딕,PingFang SC,Mircrosoft YaHei,Arial"
                    fontSize="14"
                    textAnchor="middle"
                    transform="translate(812.8 1478)"
                >
                    <tspan x="0" y="0">출입문</tspan>
                </text>
            </g>
        </svg>
    )
}

export default Songdo7thSeatSvg;

